const helpCenterQuestions = [
    {
        title: "What is Artfield?",
        description: "Learn the steps to register a new account.",
        content: [
            {
                title: "About",
                content:
                    "A social network platform for members to explore creative professionals' portfolios, follow their calendars, and connect."
            },
            {
                title: "Feed",
                content:
                    "The main feed features curated talents' works and Artfield Reads content."
            },
            {
                title: "Talents",
                content:
                    "Profiles of curated talents from different fields of art, showcasing their portfolios and calendars."
            },
            {
                title: "Reads",
                content:
                    "Editorial content including interviews, Q&A's and trend forecasts, created by Artfield."
            },
            {
                title: "Members",
                content:
                    "Profiles that anyone can create to access talents' profiles and Artfield Reads content."
            },
            {
                title: "Services",
                content:
                    "Artfield Creative Studio offers strategic creative solutions designed to meet the changing needs of brands and organizations, enhancing their value and market position."
            }
        ]
    },
    {
        title: "Create a profile",
        description: "Follow these instructions to reset your password.",
        content: [
            {
                type: "list",
                title: "For Talents",
                content: [
                    "Submit your portfolio to <a href='mailto:contact@artfieldofficial.com'><u>contact@artfieldofficial.com</u></a>.",
                    "Once your portfolio is approved, click the invitation link received via email.",
                    "Enter your details and create a password to set up your profile.",
                    "Log in to <a href='https://artfield.app/' target='_blank'><u>https://artfield.app/</u></a> or the mobile app to edit your profile."
                ]
            },
            {
                type: "list",
                title: "For Members",
                content: [
                    "Sign up at <a href='https://artfield.app/' target='_blank'><u>https://artfield.app/</u></a> or on the mobile app.",
                    "Enter your details and create a password.",
                    "Log in to <a href='https://artfield.app/' target='_blank'><u>https://artfield.app/</u></a> or the mobile app to explore talents and access Artfield Reads content."
                ]
            }
        ]
    },
    {
        title: "Personalize a profile",
        description: "Steps to edit your personal details and profile picture.",
        content: [
            {
                type: "innerQuestion",
                title: "For Talents",
                content: [
                    {
                        type: "list",
                        title: "Settings",
                        text: [
                            "Click the icon in the top right <span class='circle-icon'><img src='/icons/dots.png'></span> to edit your details, profile picture, and cover photo."
                        ],
                        content: [
                            "Profile settings → Change or remove your profile picture and cover photo.",
                            "Account settings → Edit your profile name, username, email and password.",
                            "Member settings → View your address and permissions."
                        ]
                    },
                    {
                        type: "list",
                        title: "Create work",
                        text: [
                            "To upload new work, click the icon in the right <span class='circle-icon'><img src='/icons/plus_black.png'></span>"
                        ],
                        content: [
                            "Add an impressum to define your work.",
                            "Add a caption to give more details about your work.",
                            "Upload your work (accepted formats: video, PNG, JPEG, or GIF).",
                            "Embed videos from Vimeo.",
                            "Add as many works as you wish to your carousel."
                        ]
                    },
                    {
                        type: "list",
                        title: "Edit work",
                        text: [
                            "Edit your published works by clicking the icon in the top right <span class='circle-icon'><img src='/icons/dots.png'></span>"
                        ],
                        content: [
                            "Edit your impressums, captions and visuals.",
                            "Reorder your visuals & change the cover of your carousel.",
                            "Add more visuals."
                        ]
                    },
                    {
                        type: "list",
                        title: "Delete work",
                        text: [],
                        content: [
                            "To delete your published works, click the icon in the top right <span class='circle-icon'><img src='/icons/dots.png'></span>",
                            "After this action, your work will be permanently deleted."
                        ]
                    },
                    {
                        type: "list",
                        title: "Edit your calendar",
                        text: [],
                        content: [
                            "Edit your calendar by dragging to mark your booked days."
                        ]
                    }
                ]
            },
            {
                type: "innerQuestion",
                title: "For Members",
                content: [
                    {
                        type: "list",
                        title: "Settings",
                        text: [
                            "Click the icon in the top right <span class='circle-icon'><img src='/icons/dots.png'></span> to edit your details, profile picture, and cover photo."
                        ],
                        content: [
                            "Profile settings → Change or remove your profile picture and cover photo.",
                            "Account settings → Edit your profile name, username, email and password.",
                            "Member settings → View your address and permissions."
                        ]
                    },
                    {
                        type: "list",
                        title: "Create and manage boards",
                        text: [
                            "Create a board by clicking the icon in the right <span class='circle-icon'><img src='/icons/plus_black.png'></span>"
                        ],
                        content: [
                            "Title your board.",
                            "Add a description to give more details about your board.",
                            "Boards are private to each user and not visible to others."
                        ]
                    },
                    {
                        type: "list",
                        text: [
                            "Browse works on the feed and add them to your created boards by clicking the <span class='circle-icon'><img src='/icons/plus_black.png'></span> in the top right of the works, or create a new board."
                        ],
                        content: [
                            "Choose the works you like and add them to your board.",
                            "The works you add will appear under the Boards tab in your profile."
                        ]
                    },
                    {
                        type: "list",
                        title: "Follow talents",
                        text: [],
                        content: [
                            "Browse talents by clicking Talents from the Menu.",
                            "Click the <span class='circle-icon'><img src='/icons/plus_black.png'></span> icon in the top right to follow and stay updated on talents you like.",
                            "Talents you follow will appear under the Talents tab on your profile."
                        ]
                    },
                    {
                        type: "list",
                        title: "Save reads",
                        text: [],
                        content: [
                            "Create your personal reading list from the Reads section in the Menu.",
                            "Save the reads you like by clicking the <span class='circle-icon'><img src='/icons/plus_black.png'></span> icon in the top right.",
                            "Reads you save will appear under the Reads tab on your profile."
                        ]
                    },
                ]
            }
        ]
    },
    {
        title: "Get in touch",
        description: "Find out how to get in touch with our support team.",
        content: [{content: "Get in touch with us for business inquiries, and collaborations. <br/><a href='mailto:contact@artfieldofficial.com'><u>contact@artfieldofficial.com</u></a>"}]
    },
    {
        title: "Remove profile and data",
        description: "Learn how to permanently delete your Artfield account and understand data retention policies.",
        content: [
            {
                title: "Account Deletion for Artfield App Users",
                content: "This section explains how users of the Artfield mobile application can request permanent deletion of their account and associated data."
            },
            {
                type: "list",
                title: "Steps to Request Account Deletion",
                content: [
                    "Send an email to <a href='mailto:contact@artfieldofficial.com'><u>contact@artfieldofficial.com</u></a> with the subject line 'Account Deletion Request'.",
                    "Include your registered email address and username in the email.",
                    "Clearly state that you want to permanently delete your Artfield account.",
                    "Our support team will process your request within 5-7 business days.",
                    "You will receive a confirmation email once your account has been deleted."
                ]
            },
            {
                type: "innerQuestion",
                title: "Data Types and Retention Policy",
                content: [
                    {
                        type: "list",
                        title: "Data That Will Be Deleted",
                        text: [
                            "The following data will be permanently removed when your account is deleted:"
                        ],
                        content: [
                            "Profile information (name, username, bio, profile picture)",
                            "Uploaded works, images, and media content",
                            "Boards and saved content",
                            "Followed talents and reading lists",
                            "Comments and interactions",
                            "Calendar information (for talents)",
                            "Account preferences and settings"
                        ]
                    },
                    {
                        type: "list",
                        title: "Data Retention for Legal/Technical Requirements",
                        text: [
                            "Some data may be retained for a limited period due to legal or technical requirements:"
                        ],
                        content: [
                            "Account deletion logs (retained for 30 days for security purposes)",
                            "Financial transaction records (retained for 7 years as required by law)",
                            "Legal compliance data (retained as required by applicable laws)",
                            "Backup data (permanently deleted within 30 days of account deletion)"
                        ]
                    },
                    {
                        title: "Important Notes",
                        text: [
                            "Please note that account deletion is permanent and cannot be undone.",
                            "Before requesting deletion, consider downloading any content you wish to keep.",
                            "If you have any active collaborations or business inquiries, please resolve them before deletion.",
                            "For any questions about data deletion, contact us at <a href='mailto:contact@artfieldofficial.com'><u>contact@artfieldofficial.com</u></a>."
                        ]
                    }
                ]
            }
        ]
    },
    {
        title: "Privacy, security and legal",
        description: "Understand the process to permanently remove your account.",
        content: [
            {
                type: "list-privacy",
                title: "You can find the legal terms and policies below:",
                content: [
                    "<a href='/terms-and-conditions?id=0'><u>Privacy policy</u></a>.",
                    "<a href='/terms-and-conditions?id=1'><u>Terms and conditions</u></a>.",
                    "<a href='/terms-and-conditions?id=2'><u>Copyright and trademark</u></a>.",
                    "<a href='/terms-and-conditions?id=3'><u>Clarification text</u></a>.",
                    "<a href='/terms-and-conditions?id=4'><u>Cookie policies</u></a>.",
                ]
            }
        ]
    },
    {
        title: "Download Artfield",
        description: "Understand the process to permanently remove your account.",
        content: [
            {
                type: "list-privacy",
                title: "You can find the downloads below:",
                content: [
                    "Click here to download the Artfield app on <a href='#'><u>Google Play Store</u></a>.",
                    "Click here to download the Artfield app on <a target='_blank' href='https://apps.apple.com/us/app/artfield-discover-talents/id6739311179'><u>Apple Store</u></a>.",
                ]
            }
        ]
    }
];

export default helpCenterQuestions;
